import PostCardSnsUserMuteComponent, { muteByUserId, unmuteByUserId } from '../../../components/mutes/post_card_sns_user_mute_component';
import ReplyOmitted from './reply_omitted';

/**
 * Muteクラスは、特定の要素に対してミュート/ミュート解除のアクションを設定し、
 * ユーザーのコンテンツの表示/非表示を切り替える機能を提供します。
 */
export default class Mute {
  constructor({ isCardLayout = false } = {}) {
    /**
     * レイアウトがカード形式かどうかを示します。
     * true の場合、カード形式の画面に対する処理を行います。
     * false の場合、その他の画面（リスト形式や投稿の詳細画面）に対する処理を行います。
     *
     * @type {boolean}
     * @default false
     */
    this._isCardLayout = isCardLayout;
    /**
     * 処理済みの要素を追跡するためのWeakSet。
     * @type {WeakSet<Element>}
     * @private
     */
    this._processedElements = new WeakSet();
  }

  /**
   * ミュート/ミュート解除のアクションを設定します。
   * @param {Object} options - アクション設定のオプション。
   * @param {string} options.dataType - データの種類（例: 'User', 'Chat'）。
   * @param {Element} [options.rootElement=document] - アクションを設定するルート要素。
   */
  setMuteActions({ dataType, rootElement = document }) {
    ['mute', 'unmute'].forEach((action) => {
      this._setAction(rootElement, `.js-${action}-btn[data-type="${dataType}"]`, (btn) => {
        $.modal.close();
        this._handleAction(action, btn, dataType);
      });
    });
  }

  addToggleMuteEvent({ rootElement = document } = {}) {
    if (this._isCardLayout) {
      // イニシャライザ内のイベントハンドラの登録の呼び出し
      new PostCardSnsUserMuteComponent(rootElement);
    } else {
      this._setAction(rootElement, '.js-toggle-muted-post', (btn) => this._toggleMute(btn, rootElement));
    }
  }

  _setAction(rootElement, selector, callback) {
    rootElement.querySelectorAll(selector).forEach((btn) => {
      if (this._processedElements.has(btn)) return;
      btn.addEventListener('click', () => callback(btn));
      this._processedElements.add(btn);
    });
  }

  _handleAction = (action, btn, dataType) => {
    if (dataType !== 'User') return;

    const userId = btn.dataset.id;
    const isMuteAction = action === 'mute';
    if (this._isCardLayout) {
      (isMuteAction ? muteByUserId : unmuteByUserId)(userId);
    } else {
      this._updateUserPostVisibility(userId, isMuteAction);
    }
  };

  _updateUserPostVisibility(userId, isMuted) {
    document.querySelectorAll(`.js-post[data-user-id="${userId}"]`).forEach((post) => {
      const muteLabel = post.querySelector(`.js-post-mute-label[data-user-id="${userId}"]`);
      const postContent = post.querySelector(`.js-post-content[data-user-id="${userId}"]`);

      if (isMuted) {
        muteLabel.classList.remove('hidden');
        postContent.classList.add('hidden');
      } else {
        muteLabel.classList.add('hidden');
        postContent.classList.remove('hidden');
      }
    });
  }

  _toggleMute(btn, rootElement) {
    const post = btn.closest('.js-post');
    const postContent = post.querySelector('.js-post-content');

    if (post.dataset.tmpMuted === 'true') {
      post.dataset.tmpMuted = 'false';
      postContent.classList.remove('hidden');
      btn.innerText = '投稿を非表示';

      new ReplyOmitted('.js-reply-omitted', rootElement);
    } else {
      post.dataset.tmpMuted = 'true';
      postContent.classList.add('hidden');
      btn.innerText = '投稿を表示';
    }
  }
}
